import React from 'react';

import classes from './ConnectorGroup.module.scss';
import classNames from 'classnames';
import { ConnectorType } from 'utils/enums/chargingType';

type Props = {
  connectorImg: string;
  type: ConnectorType;
  available: number;
  total: number;
  maxVoltage: number;
  address?: string;
  availableGroup: boolean;
};

const ConnectorGroupView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classes['container']}>
      <div className={`${classes['content']} ${props.availableGroup ? classes['content--availeble'] : classes['content--unavaileble']}`}>
        <div className={classes['body']}>
          <img className={classes['img']} src={props.connectorImg} />
          <div className={classes['details']}>
            <div className={classes['center']}>{props.type}</div>
            <div className={classNames(classes['center'], classes['center--bottom'])}>{props.maxVoltage} kW</div>
          </div>
          <div className={classes['ratio']}>
            <div className={classes['center']}>
              {props.availableGroup ? (
                <div className={classes['center--availeble']}>Availeble</div>
              ) : (
                <div className={classes['center--unavaileble']}>All In Use</div>
              )}
            </div>
            <div className={classNames(classes['center'], classes['center--bottom'])}>
              {props.available.toString()} / {props.total ? props.total.toString() : '1'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ConnectorGroupView.displayName = 'ConnectorGroupView';
ConnectorGroupView.defaultProps = {};

export default ConnectorGroupView;
